import ChooseOne from './choose-one'
import ChooseMany from './choose-many'
import DateComponent from './date'
export default {
	chooseOne: ChooseOne,
	chooseMany: ChooseMany,
	date: DateComponent
}
